import { isFeatureEnabled } from '@lumapps/features';
import { JOURNEYS_FF } from '@lumapps/journeys/constants';
import { createSelector } from '@lumapps/redux/reselect';

export const isJourneysEnabled = isFeatureEnabled(JOURNEYS_FF);

export const canAccessEndUserJourneys = createSelector([isJourneysEnabled], (isJourneysEnabled) => isJourneysEnabled);
